const state = () => ({
  flashcards: [],
  groupingId: null,
  fallbackCategoryId: null,
});

const getters = {
  flashcards: state => state.flashcards,
  groupingId: state => state.groupingId,
  fallbackCategoryId: state => state.fallbackCategoryId,
};

const mutations = {
  setFlashcards(state, flashcards) {
    state.flashcards = flashcards;
  },
  setGroupingId(state, groupingId) {
    state.groupingId = groupingId;
  },
  setFallbackCategoryId(state, categoryId) {
    state.fallbackCategoryId = categoryId;
  },
};

const actions = {
  fetchLearningPath({ commit, rootGetters }) {
    return rootGetters['session/ajax'].get('/learning_path').then(response => {
      commit('setFlashcards', response.data);
      return response.data;
    });
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
